import script from "./Article.vue?vue&type=script&setup=true&lang=js"
export * from "./Article.vue?vue&type=script&setup=true&lang=js"

import "./Article.vue?vue&type=style&index=0&id=4a7fba7c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7fba7c"]])

export default __exports__